/*
 * BYŌDŌ · Selector de la ficha (plantilla product.byodo)
 * Estado {edicion, idioma, pack} → producto/variante REAL (con su SKU) → /cart/add.js
 * Otras secciones se enganchan con atributos data-byodo-* y con el evento 'byodo:change'.
 */
(function () {
  'use strict';

  var LANGS = ['es', 'ca', 'en'];
  var EDS = ['premium', 'original'];
  var PACKS = [1, 3, 6];

  function langOf(option) {
    var o = String(option || '').toLowerCase();
    if (o.indexOf('catal') === 0) return 'ca';
    if (o.indexOf('engl') === 0) return 'en';
    return 'es';
  }

  // 5900 → "59 €" (auto) · "59,00 €" (fixed)
  function money(cents, mode) {
    var v = (cents || 0) / 100;
    var whole = Math.round(v * 100) % 100 === 0;
    var opts = (mode === 'auto' && whole)
      ? { minimumFractionDigits: 0, maximumFractionDigits: 0 }
      : { minimumFractionDigits: 2, maximumFractionDigits: 2 };
    return v.toLocaleString('es-ES', opts) + ' €';
  }

  function $(root, sel) { return root.querySelector(sel); }
  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function ByodoFicha(root) {
    this.root = root;
    var json = $(root, '[data-bf-json]');
    if (!json) return;
    try { this.data = JSON.parse(json.textContent); } catch (e) { console.error('[BYŌDŌ] JSON del selector no válido', e); return; }

    var products = this.data.products || {};
    Object.keys(products).forEach(function (k) {
      var p = products[k];
      if (p && p.variants) p.variants.forEach(function (v) { v.lang = langOf(v.option1); });
    });

    this.state = {
      edicion: this.data.initial.edicion,
      pack: this.data.initial.pack,
      idioma: this.data.initial.idioma,
      addon: false,
      addonLang: null,
      addonLangTouched: false
    };
    this.interacted = false;
    this.busy = false;
    this.readUrl();
    this.sanitize();
    this.bind();
    this.initGallery();
    this.initSticky();
    this.render({ url: false, gallery: true });
    root.classList.add('is-ready');
  }

  var P = ByodoFicha.prototype;

  /* ---------- Datos ---------- */
  P.key = function (ed, pack) { return ed + '_' + (pack === 1 ? '1' : 'x' + pack); };
  P.product = function (ed, pack) {
    ed = ed || this.state.edicion; pack = pack || this.state.pack;
    return this.data.products[this.key(ed, pack)] || null;
  };
  P.variant = function (ed, pack, lang) {
    ed = ed || this.state.edicion; pack = pack || this.state.pack; lang = lang || this.state.idioma;
    var p = this.product(ed, pack);
    if (!p || !p.variants || !p.variants.length) return null;
    if (ed === 'premium') return p.variants[0];
    for (var i = 0; i < p.variants.length; i++) if (p.variants[i].lang === lang) return p.variants[i];
    return p.variants[0];
  };
  P.addonProduct = function () { return this.data.products.instrucciones || null; };
  P.addonVariant = function () {
    var p = this.addonProduct();
    if (!p) return null;
    var lang = this.state.addonLang || 'es';
    for (var i = 0; i < p.variants.length; i++) if (langOf(p.variants[i].option1) === lang) return p.variants[i];
    return p.variants[0];
  };
  P.defaultAddonLang = function () { return this.state.edicion === 'original' ? this.state.idioma : 'es'; };
  P.total = function () {
    var v = this.variant();
    var t = v ? v.price : 0;
    if (this.state.addon) { var av = this.addonVariant(); if (av && av.available) t += av.price; }
    return t;
  };

  P.readUrl = function () {
    var q = new URLSearchParams(window.location.search);
    var ed = (q.get('edicion') || '').toLowerCase();
    var lang = (q.get('idioma') || '').toLowerCase();
    var pack = parseInt(q.get('pack'), 10);
    if (EDS.indexOf(ed) > -1) this.state.edicion = ed;
    if (LANGS.indexOf(lang) > -1) this.state.idioma = lang;
    if (PACKS.indexOf(pack) > -1) this.state.pack = pack;
    if (q.get('instrucciones') === '1') this.state.addon = true;
  };

  P.sanitize = function () {
    if (!this.product(this.state.edicion, 1)) this.state.edicion = this.product('premium', 1) ? 'premium' : 'original';
    if (!this.product(this.state.edicion, this.state.pack)) this.state.pack = 1;
    if (this.state.edicion === 'premium') this.state.idioma = this.state.idioma || 'es';
    if (!this.state.addonLangTouched) this.state.addonLang = this.defaultAddonLang();
  };

  /* ---------- Acciones públicas ---------- */
  P.set = function (patch, opts) {
    for (var k in patch) if (Object.prototype.hasOwnProperty.call(patch, k)) this.state[k] = patch[k];
    this.interacted = true;
    this.sanitize();
    this.render({ url: true, gallery: true, scrollGallery: !!(opts && opts.scrollGallery) });
  };
  P.setEdition = function (ed) { if (EDS.indexOf(ed) > -1) this.set({ edicion: ed }, { scrollGallery: true }); };
  P.setPack = function (n) { n = parseInt(n, 10); if (PACKS.indexOf(n) > -1) this.set({ pack: n }, { scrollGallery: true }); };
  P.setLang = function (l) { if (LANGS.indexOf(l) > -1) this.set({ idioma: l }); };
  P.setAddon = function (on) { this.set({ addon: !!on }); };
  P.scrollToSelector = function () {
    var el = $(this.root, '[data-bf-selector]');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  /* ---------- Eventos ---------- */
  P.bind = function () {
    var self = this;
    var root = this.root;

    $$(root, '[data-bf-edicion]').forEach(function (b) {
      b.addEventListener('click', function () { self.setEdition(b.getAttribute('data-bf-edicion')); });
    });
    $$(root, '[data-bf-idioma]').forEach(function (b) {
      b.addEventListener('click', function () { self.setLang(b.getAttribute('data-bf-idioma')); });
    });
    $$(root, '[data-bf-pack]').forEach(function (b) {
      b.addEventListener('click', function () { self.setPack(b.getAttribute('data-bf-pack')); });
    });
    var addon = $(root, '[data-bf-addon]');
    if (addon) addon.addEventListener('change', function () { self.setAddon(addon.checked); });
    $$(root, '[data-bf-addon-idioma]').forEach(function (b) {
      b.addEventListener('click', function () {
        self.state.addonLangTouched = true;
        self.set({ addonLang: b.getAttribute('data-bf-addon-idioma') });
      });
    });

    var form = $(root, '[data-bf-form]');
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); self.addToCart(e.submitter || $(root, '[data-bf-main-btn]')); });
    var stickyBtn = $(root, '[data-bf-sticky-btn]');
    if (stickyBtn) stickyBtn.addEventListener('click', function () { self.addToCart(stickyBtn); });

    // Enganches desde otras secciones de la ficha (comparativa, packs, juegos, vídeo…)
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-byodo-set-edicion],[data-byodo-set-pack],[data-byodo-addon-on],[data-byodo-add],[data-byodo-goto]') : null;
      if (!t || root.contains(t)) return;
      e.preventDefault();
      if (t.hasAttribute('data-byodo-set-edicion')) self.setEdition(t.getAttribute('data-byodo-set-edicion'));
      if (t.hasAttribute('data-byodo-set-pack')) self.setPack(t.getAttribute('data-byodo-set-pack'));
      if (t.hasAttribute('data-byodo-addon-on')) self.setAddon(true);
      if (t.hasAttribute('data-byodo-add')) { self.addToCart(t); return; }
      self.scrollToSelector();
    });

    // Si vuelven atrás desde el carrito (bfcache), el botón no puede quedarse en «Añadiendo…»
    window.addEventListener('pageshow', function (e) { if (e.persisted) self.setBusy(false); });
  };

  /* ---------- Pintado ---------- */
  P.render = function (opts) {
    opts = opts || {};
    var s = this.state;
    var root = this.root;
    var v = this.variant();
    var p = this.product();
    var labels = this.data.labels || {};
    var self = this;

    // Edición
    $$(root, '[data-bf-edicion]').forEach(function (b) {
      var ed = b.getAttribute('data-bf-edicion');
      var on = ed === s.edicion;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var base = self.variant(ed, 1, ed === 'original' ? s.idioma : 'es');
      var price = b.querySelector('[data-bf-ed-price]');
      if (price && base) price.textContent = money(base.price, 'auto');
      var vv = self.variant(ed, s.pack, ed === 'original' ? s.idioma : 'es');
      var soldout = !vv || !vv.available;
      b.classList.toggle('is-soldout', soldout);
      var tag = b.querySelector('[data-bf-soldout-tag]');
      if (tag) tag.hidden = !soldout;
    });

    // Idioma (solo Original)
    var langRow = $(root, '[data-bf-lang-row]');
    if (langRow) langRow.classList.toggle('is-open', s.edicion === 'original');
    $$(root, '[data-bf-idioma]').forEach(function (b) {
      var l = b.getAttribute('data-bf-idioma');
      b.setAttribute('aria-pressed', l === s.idioma ? 'true' : 'false');
      b.tabIndex = s.edicion === 'original' ? 0 : -1;
      var lv = self.variant('original', s.pack, l);
      b.classList.toggle('is-soldout', !!lv && !lv.available);
    });

    // Cantidad
    var unit = this.variant(s.edicion, 1);
    $$(root, '[data-bf-pack]').forEach(function (b) {
      var n = parseInt(b.getAttribute('data-bf-pack'), 10);
      var pv = self.variant(s.edicion, n);
      b.hidden = !pv;
      b.setAttribute('aria-pressed', n === s.pack ? 'true' : 'false');
      b.classList.toggle('is-soldout', !!pv && !pv.available);
      if (!pv) return;
      var head = b.querySelector('[data-bf-pack-head-price]');
      var sub = b.querySelector('[data-bf-pack-sub]');
      if (n === 1) {
        if (head) head.textContent = '';
        if (sub) sub.textContent = pv.available ? money(pv.price, 'auto') : (labels.soldout || 'Agotado');
      } else {
        if (head) head.textContent = ' · ' + money(pv.price, 'auto');
        if (sub) {
          if (!pv.available) { sub.textContent = labels.soldout || 'Agotado'; return; }
          var per = Math.round(pv.price / n);
          var save = unit ? unit.price * n - pv.price : 0;
          sub.innerHTML = '';
          sub.appendChild(document.createTextNode(money(per, 'auto') + '/ud'));
          if (save > 0) {
            sub.appendChild(document.createTextNode(' · '));
            var sv = document.createElement('span');
            sv.className = 'bf__save';
            sv.textContent = 'ahorras ' + money(save, 'auto');
            sub.appendChild(sv);
          }
        }
      }
    });

    // Add-on
    var addonWrap = $(root, '[data-bf-addon-wrap]');
    if (addonWrap) {
      if (!s.addonLangTouched) s.addonLang = this.defaultAddonLang();
      var av = this.addonVariant();
      var addonOk = !!av && av.available;
      var check = $(root, '[data-bf-addon]');
      if (!addonOk) s.addon = false;
      if (check) { check.checked = s.addon; check.disabled = !addonOk; }
      addonWrap.classList.toggle('is-on', s.addon);
      addonWrap.classList.toggle('is-disabled', !addonOk);
      var ap = $(root, '[data-bf-addon-price]');
      if (ap && av) ap.textContent = money(av.price, 'fixed');
      var sub2 = $(root, '[data-bf-addon-sub]');
      if (sub2) sub2.textContent = addonOk ? (labels.addonSub || '') : (labels.addonSoldout || '');
      var inline = $(root, '[data-bf-addon-lang-inline]');
      if (inline) inline.textContent = s.addon ? ' · ' + String(s.addonLang || 'es').toUpperCase() : '';
      var aRow = $(root, '[data-bf-addon-lang-row]');
      if (aRow) aRow.classList.toggle('is-open', s.addon);
      $$(root, '[data-bf-addon-idioma]').forEach(function (b) {
        var l = b.getAttribute('data-bf-addon-idioma');
        b.setAttribute('aria-pressed', l === s.addonLang ? 'true' : 'false');
        b.tabIndex = s.addon ? 0 : -1;
        var p2 = self.addonProduct();
        var lv = null;
        if (p2) for (var i = 0; i < p2.variants.length; i++) if (langOf(p2.variants[i].option1) === l) lv = p2.variants[i];
        b.hidden = !lv;
        b.classList.toggle('is-soldout', !!lv && !lv.available);
      });
    }

    // Título, precio, tachado, estrellas
    if (p) $$(root, '[data-bf-title]').forEach(function (el) { el.textContent = p.title; });
    if (v) {
      $$(root, '[data-bf-price]').forEach(function (el) { el.textContent = money(v.price, 'fixed'); });
      $$(root, '[data-bf-compare]').forEach(function (el) {
        var show = v.compare && v.compare > v.price;
        el.hidden = !show;
        el.textContent = show ? money(v.compare, 'fixed') : '';
      });
      var input = $(root, '[data-bf-input-id]');
      if (input) input.value = v.id;
    }
    var base = this.product(s.edicion, 1);
    var rating = $(root, '[data-bf-rating]');
    if (rating && base) {
      var hasR = base.rating && base.ratingCount;
      rating.hidden = !hasR;
      if (hasR) {
        var stars = rating.querySelector('.bf__stars');
        if (stars) stars.style.setProperty('--r', base.rating);
        var rv = rating.querySelector('[data-bf-rating-val]');
        if (rv) rv.textContent = Number(base.rating).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        var rc = rating.querySelector('[data-bf-rating-count]');
        if (rc) rc.textContent = base.ratingCount + (base.ratingCount === 1 ? ' reseña' : ' reseñas');
      }
    }

    // Botones
    var total = this.total();
    var available = !!v && v.available;
    var other = s.edicion === 'premium' ? 'original' : 'premium';
    var otherV = this.variant(other, s.pack, other === 'original' ? s.idioma : 'es');
    var soldText = (otherV && otherV.available)
      ? (other === 'original' ? labels.tryOriginal : labels.tryPremium)
      : (labels.soldout || 'Agotado');
    var mainBtn = $(root, '[data-bf-main-btn]');
    if (mainBtn && !this.busy) {
      mainBtn.disabled = !available;
      var t = mainBtn.querySelector('[data-bf-btn-text]') || mainBtn;
      t.textContent = available ? (labels.button + ' · ' + money(total, 'auto')) : soldText;
    }
    var sBtn = $(root, '[data-bf-sticky-btn]');
    if (sBtn && !this.busy) {
      sBtn.disabled = !available;
      sBtn.textContent = available ? labels.button : (labels.soldout || 'Agotado');
    }
    var sp = $(root, '[data-bf-sticky-price]');
    if (sp) sp.textContent = money(total, 'fixed');
    var ss = $(root, '[data-bf-sticky-sum]');
    if (ss) ss.textContent = this.summary();

    // Galería
    if (opts.gallery !== false) this.swapGallery(opts.scrollGallery);

    // Otras secciones (comparativa, packs, «Así lo recibirás», botones…)
    this.paintExternal(total, available);

    // URL compartible
    if (opts.url && this.interacted) this.writeUrl();

    var detail = {
      state: { edicion: s.edicion, idioma: s.idioma, pack: s.pack, addon: s.addon, addonLang: s.addonLang },
      product: p, variant: v, addonVariant: s.addon ? this.addonVariant() : null, total: total, available: available
    };
    document.dispatchEvent(new CustomEvent('byodo:change', { detail: detail }));
  };

  P.summary = function () {
    var s = this.state;
    var parts = [s.edicion === 'premium' ? 'Premium' : 'Original'];
    if (s.edicion === 'original') parts.push(String(s.idioma).toUpperCase());
    if (s.pack !== 1) parts.push('x' + s.pack);
    var txt = parts.join(' · ');
    if (s.addon) txt += ' + instrucciones';
    else if (parts.length === 1 && this.data.labels.shipping) txt += ' · ' + this.data.labels.shipping;
    return txt;
  };

  P.paintExternal = function (total, available) {
    var s = this.state;
    var self = this;
    $$(document, '[data-byodo-when-edicion]').forEach(function (el) {
      el.hidden = el.getAttribute('data-byodo-when-edicion') !== s.edicion;
    });
    $$(document, '[data-byodo-highlight-edicion]').forEach(function (el) {
      el.classList.toggle('is-active', el.getAttribute('data-byodo-highlight-edicion') === s.edicion);
    });
    $$(document, '[data-byodo-price-of]').forEach(function (el) {
      var arg = el.getAttribute('data-byodo-price-of').split(':'); // "x3" o "original:1"
      var ed = arg.length > 1 ? arg[0] : s.edicion;
      var n = parseInt(String(arg[arg.length - 1]).replace('x', ''), 10) || 1;
      var vv = self.variant(ed, n, ed === 'original' ? s.idioma : 'es');
      if (vv) el.textContent = money(vv.price, 'auto');
    });
    $$(document, '[data-byodo-compare-of]').forEach(function (el) {
      var n = parseInt(String(el.getAttribute('data-byodo-compare-of')).replace('x', ''), 10) || 1;
      var vv = self.variant(s.edicion, n);
      var show = vv && vv.compare > vv.price;
      el.hidden = !show;
      if (show) el.textContent = money(vv.compare, 'auto');
    });
    $$(document, '[data-byodo-image-of]').forEach(function (el) {
      var n = parseInt(String(el.getAttribute('data-byodo-image-of')).replace('x', ''), 10) || 1;
      var pp = self.product(s.edicion, n);
      if (pp && pp.image && el.tagName === 'IMG') {
        el.src = pp.image.src; el.srcset = pp.image.srcset || ''; el.alt = pp.title; el.hidden = false;
      }
    });
    $$(document, '[data-byodo-total]').forEach(function (el) {
      if (self.root.contains(el)) return;
      el.textContent = money(total, 'auto');
    });
    $$(document, '[data-byodo-add]').forEach(function (el) {
      if (self.root.contains(el)) return;
      if (el.tagName === 'BUTTON') el.disabled = !available;
    });
  };

  P.writeUrl = function () {
    try {
      var s = this.state;
      var url = new URL(window.location.href);
      url.searchParams.delete('variant');
      url.searchParams.set('edicion', s.edicion);
      if (s.edicion === 'original') url.searchParams.set('idioma', s.idioma); else url.searchParams.delete('idioma');
      url.searchParams.set('pack', String(s.pack));
      if (s.addon) url.searchParams.set('instrucciones', '1'); else url.searchParams.delete('instrucciones');
      window.history.replaceState(window.history.state, '', url.pathname + '?' + url.searchParams.toString() + url.hash);
    } catch (e) { /* navegadores antiguos: sin URL compartible */ }
  };

  /* ---------- Galería ---------- */
  // Las fotos de la galería son las del producto elegido (edición + cantidad); se rehacen al cambiar.
  function sized(src, w) {
    try { var u = new URL(src, window.location.href); u.searchParams.set('width', String(w)); return u.toString(); } catch (e) { return src; }
  }

  P.initGallery = function () {
    var self = this;
    var track = $(this.root, '[data-bf-track]');
    if (!track) return;
    this.track = track;
    this.thumbsWrap = $(this.root, '[data-bf-thumbs]');
    this.counter = $(this.root, '[data-bf-counter]');
    this.pills = $(this.root, '[data-bf-pills]');
    this.shownId = this.data.pageProductId;
    this.collectGallery();
    this.index = 0;
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; self.syncGallery(); });
    }, { passive: true });
    if (this.thumbsWrap) this.thumbsWrap.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-bf-thumb]') : null;
      if (t) self.goTo(self.thumbs.indexOf(t));
    });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); self.goTo(self.index + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); self.goTo(self.index - 1); }
    });
  };

  P.collectGallery = function () {
    this.slides = $$(this.track, '[data-bf-slide]');
    this.thumbs = this.thumbsWrap ? $$(this.thumbsWrap, '[data-bf-thumb]') : [];
    this.thumbs.forEach(function (t, k) { t.setAttribute('aria-label', 'Ver foto ' + (k + 1)); });
  };

  P.syncGallery = function (force) {
    if (!this.track) return;
    var w = this.track.clientWidth || 1;
    var i = Math.round(this.track.scrollLeft / w);
    i = Math.max(0, Math.min(i, this.slides.length - 1));
    if (i === this.index && !force) return;
    this.index = i;
    if (this.counter) this.counter.textContent = (i + 1) + '/' + this.slides.length;
    this.thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    if (this.pills) this.pills.classList.toggle('is-hidden', i !== 0);
  };

  P.goTo = function (i, instant) {
    if (!this.track || !this.slides.length) return;
    i = Math.max(0, Math.min(i, this.slides.length - 1));
    if (instant) {
      // Sin animación (el carril tiene scroll-behavior: smooth en CSS)
      var prev = this.track.style.scrollBehavior;
      this.track.style.scrollBehavior = 'auto';
      this.track.scrollLeft = i * this.track.clientWidth;
      this.track.style.scrollBehavior = prev;
    } else {
      this.track.scrollTo({ left: i * this.track.clientWidth, behavior: 'smooth' });
    }
    var thumb = this.thumbs[i];
    if (thumb && this.thumbsWrap) {
      var wr = this.thumbsWrap.getBoundingClientRect();
      var tr = thumb.getBoundingClientRect();
      if (tr.left < wr.left || tr.right > wr.right) {
        this.thumbsWrap.scrollBy({ left: tr.left - wr.left - 8, behavior: instant ? 'auto' : 'smooth' });
      }
    }
  };

  P.buildMedia = function (p) {
    var track = this.track;
    var wrap = this.thumbsWrap;
    var title = p.title || '';
    $$(track, '[data-bf-media]').forEach(function (el) { el.parentNode.removeChild(el); });
    if (wrap) $$(wrap, '[data-bf-media-thumb]').forEach(function (el) { el.parentNode.removeChild(el); });
    p.media.forEach(function (m, k) {
      var slide = document.createElement('div');
      slide.className = 'bf__slide';
      slide.setAttribute('data-bf-slide', '');
      slide.setAttribute('data-bf-media', '');
      var img = document.createElement('img');
      img.alt = m.alt || title;
      img.loading = k === 0 ? 'eager' : 'lazy';
      img.decoding = 'async';
      img.sizes = '(min-width: 990px) 55vw, 100vw';
      img.srcset = [400, 600, 800, 1000, 1200, 1600].map(function (w) { return sized(m.src, w) + ' ' + w + 'w'; }).join(', ');
      img.src = m.src;
      slide.appendChild(img);
      track.appendChild(slide);
      if (wrap) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'bf__thumb';
        b.setAttribute('data-bf-thumb', '');
        b.setAttribute('data-bf-media-thumb', '');
        var ti = document.createElement('img');
        ti.src = sized(m.src, 160);
        ti.alt = '';
        ti.loading = 'lazy';
        b.appendChild(ti);
        wrap.appendChild(b);
      }
    });
    this.collectGallery();
  };

  P.swapGallery = function (scrollTo) {
    if (!this.track) return;
    var p = this.product();
    var changed = false;
    if (p && p.media && p.media.length && p.id !== this.shownId) {
      this.buildMedia(p);
      this.shownId = p.id;
      changed = true;
    }
    if (!scrollTo && !changed) return;
    var first = $(this.track, '[data-bf-media]');
    var idx = first ? this.slides.indexOf(first) : 0;
    if (changed) {
      this.goTo(idx, true);
      if (this.thumbsWrap && idx === 0) this.thumbsWrap.scrollLeft = 0;
      this.syncGallery(true);
    } else if (idx > -1 && idx !== this.index) {
      this.goTo(idx);
    }
  };

  /* ---------- Barra fija ---------- */
  P.initSticky = function () {
    var self = this;
    var bar = $(this.root, '[data-bf-sticky]');
    var btn = $(this.root, '[data-bf-main-btn]');
    if (!bar || !btn) return;
    this.bar = bar;
    document.body.classList.add('bf-has-sticky');
    if (!('IntersectionObserver' in window)) return;
    // Visible siempre que el botón principal no se vea casi entero (por arriba o porque aún no se ha llegado a él)
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      self.toggleSticky(e.intersectionRatio < 0.8);
    }, { threshold: [0, 0.8, 1], rootMargin: '-72px 0px -76px 0px' });
    io.observe(btn);
  };

  P.toggleSticky = function (show) {
    if (!this.bar) return;
    this.bar.classList.toggle('is-visible', show);
    this.bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    if (show) this.bar.removeAttribute('inert'); else this.bar.setAttribute('inert', '');
  };

  /* ---------- Carrito ---------- */
  P.setBusy = function (on) {
    this.busy = on;
    var labels = this.data.labels || {};
    var btns = $$(this.root, '[data-bf-add]');
    btns.forEach(function (b) {
      if (on) {
        b.setAttribute('aria-busy', 'true');
        var t = b.querySelector('[data-bf-btn-text]') || b;
        t.textContent = labels.adding || 'Añadiendo…';
      } else {
        b.removeAttribute('aria-busy');
      }
    });
    if (!on) this.render({ url: false, gallery: false });
  };

  P.showError = function (msg) {
    var el = $(this.root, '[data-bf-error]');
    if (!el) return;
    el.textContent = msg || (this.data.labels && this.data.labels.error) || 'No se ha podido añadir. Inténtalo de nuevo.';
    el.hidden = false;
    clearTimeout(this._errT);
    this._errT = setTimeout(function () { el.hidden = true; }, 7000);
  };

  P.addToCart = function (source) {
    var self = this;
    if (this.busy) return;
    var v = this.variant();
    if (!v || !v.available) return;
    var items = [{ id: v.id, quantity: 1 }];
    if (this.state.addon) {
      var av = this.addonVariant();
      if (av && av.available) items.push({ id: av.id, quantity: 1 });
    }
    var err = $(this.root, '[data-bf-error]');
    if (err) err.hidden = true;
    this.setBusy(true);

    var routes = (window.theme && window.theme.routes) || {};
    var addUrl = (routes.cart_add_url || '/cart/add') + '.js';
    var cartUrl = routes.cart_url || '/cart';

    // Secciones que el tema quiera refrescar (si algún día se activa el cajón del carrito)
    var sections = [];
    try { document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sections } })); } catch (e) {}
    var body = { items: items };
    if (sections.length) { body.sections = sections.join(','); body.sections_url = window.location.pathname; }

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok || res.json.status) {
          var d = res.json && (res.json.description || res.json.message);
          throw new Error(typeof d === 'string' ? d : '');
        }
        try { document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: res.json } })); } catch (e) {}
        var drawer = document.querySelector('cart-drawer');
        var t = window.theme || {};
        var useDrawer = drawer && typeof drawer.show === 'function' && t.pubsub && t.settings && t.settings.cartType !== 'page';
        if (useDrawer) {
          return fetch(cartUrl + '.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              cart.sections = res.json.sections;
              t.pubsub.publish(t.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'byodo-selector', productVariantId: v.id, cart: cart });
              drawer.show(source);
              self.setBusy(false);
            });
        }
        if (window.Shopify && window.Shopify.designMode) {
          self.setBusy(false);
          self.showError('Añadido al carrito (en el editor no se abre el carrito).');
          return;
        }
        window.location.href = cartUrl;
      })
      .catch(function (e) {
        self.setBusy(false);
        self.showError(e && e.message ? e.message : null);
      });
  };

  /* ---------- Arranque ---------- */
  function init(scope) {
    $$(scope || document, '[data-bf-root]').forEach(function (root) {
      if (root.__byodo) return;
      root.__byodo = new ByodoFicha(root);
      window.BYODO = root.__byodo;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
